import { jsxs as i, jsx as t } from "react/jsx-runtime";
const h = ({
  width: e = 55,
  height: r = 27,
  color: o = "currentColor",
  fill: n = "#E5E7EB",
  ...s
}) => /* @__PURE__ */ i("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: `0 0 ${e} ${r}`, fill: "none", ...s, children: [
  /* @__PURE__ */ t("rect", { x: "1", y: "1", width: "53", height: "25", rx: "12.5", stroke: o, strokeWidth: "2" }),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M34.5 2H41.5C47.8513 2 53 7.14873 53 13.5C53 19.8513 47.8513 25 41.5 25H27L34.5 2Z",
      fill: n
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M46.6667 9.36838L37.3334 18.7017M37.3334 9.36838L46.6667 18.7017",
      stroke: "black",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ),
  /* @__PURE__ */ t(
    "path",
    {
      d: "M23.1499 9.54504L14.8999 17.795L11.1499 14.045",
      stroke: o,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
] });
export {
  h as LegalCheckIcon
};
